// extracted by extract-css-chunks-webpack-plugin
module.exports = {"border-wrapper":"border-wrapper","border-blue":"border-blue","border-green":"border-green","inverse":"inverse","mobile-border":"mobile-border"};